import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Quote } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { DiscoverArticle } from '../entities/discover-article.entity';
import { DiscoverListAndLinksDetails } from '../entities/discover-lists-and-links.entity';
import { DiscoverOverview } from '../entities/discover-overview.entity';
import { MultiOrderStrategiesOverview, MultiOrderStrategyDetails } from '../entities/multi-order-strategy.entity';

@Injectable({ providedIn: 'root' })
export class DiscoverInfrastructure {
  #http = inject(HttpClient);
  #discoverEndpoint = `${environment.apihost}/api/discover`;
  #quoteEndpoint = `${environment.apihost}/api/quote`;
  #multiOrderStrategiesEndpoint = `${environment.apihost}/api/multi-order/strategy`;

  public getQuotes(isins: string[]): Observable<Quote[]> {
    return this.#http.get<Quote[]>(`${this.#quoteEndpoint}?isins=${isins.join()}`);
  }

  public getPrevQuotes(isins: string[]): Observable<Quote[]> {
    return this.#http.get<Quote[]>(`${this.#quoteEndpoint}/prev?isins=${isins.join()}`);
  }

  public getDiscoverOverview(): Observable<DiscoverOverview> {
    return this.#http.get<DiscoverOverview>(`${this.#discoverEndpoint}/overview`);
  }

  public getDiscoverTodayDetails(id: string): Observable<DiscoverArticle> {
    return this.#http.get<DiscoverArticle>(`${this.#discoverEndpoint}/today/${id}`);
  }

  public getDiscoverMegatrendDetails(id: string): Observable<DiscoverArticle> {
    return this.#http.get<DiscoverArticle>(`${this.#discoverEndpoint}/megatrend/${id}`);
  }

  public getDiscoverKnowHowDetails(id: string): Observable<DiscoverArticle> {
    return this.#http.get<DiscoverArticle>(`${this.#discoverEndpoint}/know-how/${id}`);
  }

  public getDiscoverListDetails(id: string): Observable<DiscoverListAndLinksDetails> {
    return this.#http.get<DiscoverListAndLinksDetails>(`${this.#discoverEndpoint}/list/${id}`);
  }

  public getMultiOrderStrategyOverview(): Observable<MultiOrderStrategiesOverview> {
    return this.#http.get<MultiOrderStrategiesOverview>(`${this.#multiOrderStrategiesEndpoint}/overview`);
  }

  public getMultiOrderStrategy(id: string): Observable<MultiOrderStrategyDetails> {
    return this.#http.get<MultiOrderStrategyDetails>(`${this.#multiOrderStrategiesEndpoint}/${id}`);
  }
}
